export default {
      id: "LOGO-FOOTER-HORIZONTAL-usage",
      viewBox: "0 0 363 74",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#LOGO-FOOTER-HORIZONTAL-usage",
      toString: function () {
        return this.url;
      }
    }